// extracted by mini-css-extract-plugin
export default {"title":"Welcome_title__tMgUw","text__content":"Welcome_text__content__zDvGh","text":"Welcome_text__+X0KA","portfolio":"Welcome_portfolio__5likr"};